import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ScreenRuta from "../../../assets/images/pantalla_Route.webp";
import ScreenInitRoute from "../../../assets/images/initRoute.webp";
import LoginApp from "../../../assets/images/loginApp.webp";
import ProfileApp from "../../../assets/images/profileApp.webp";

const ModalNextToTheApp = ({ open, onClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 2,
          //   background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        },
      }}
    >
      <DialogTitle
        sx={{ fontWeight: "bold", color: "#e7ef7d", textAlign: "center" }}
      >
        ¡Nuestra aplicación para runners está en camino!
      </DialogTitle>

      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <DialogContentText
          sx={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            fontStyle: "italic",
            fontWeight: "medium",
          }}
        >
          Pronto podrás explorar nuevas rutas, desafiar tus límites y unirte a
          una comunidad apasionada por el running.
        </DialogContentText>
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
          <Box>
            <img src={LoginApp} alt="Pantalla de rutas en App." width={100} />
          </Box>
          <Box>
            <img
              src={ScreenInitRoute}
              alt="Pantalla de rutas en App."
              width={100}
            />
          </Box>
          <Box>
            <img src={ProfileApp} alt="Pantalla de rutas en App." width={100} />
          </Box>
          <Box>
            <img
              src={ScreenRuta}
              alt="Pantalla de iniciar ruta en App."
              width={100}
            />
          </Box>
        </Box>
        <DialogContentText
          sx={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            fontStyle: "italic",
            fontWeight: "medium",
          }}
        >
          "Cada kilómetro comienza con un primer paso. Estamos casi listos para
          acompañarte en tu próxima aventura."
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Button
          onClick={onClose}
          variant="contained"
          size="large"
          sx={{
            borderRadius: 50,
            backgroundColor: "#e7ef7d",
            px: 4,
            py: 1,
            fontWeight: "bold",
            textTransform: "none",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0 6px 8px rgba(0, 0, 0, 0.15)",
            },
          }}
        >
          ¡Entendido! Estaré atento
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalNextToTheApp;
